import {Component} from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import reformatDateToDisplay from '../../objects/CommonUse/reformatDateToDisplay_function';
import { standardNumberFormat, doubleToStringMonthly } from '../../objects/CommonUse/double_functions';
import CreditReportFactors from './datasets/credit_report_factors';
import ThreeColumnTableCard from './three_column_table_card';
import { loanBalanceCalcFunction } from '../../objects/AssetsExpenses/loan_balance_calc_function';
import CreditReportLoanCard from './credit_report_loan_card';
import TwoColumnTableCard from './two_column_table_card';
import creditReportCreditCard from './objectsStatus/credit_report_credit_card';


class CreditReportModal extends Component {
  constructor(props) {
    super(props);
    this.state={
         
    };   
    this.creditRating = "";
    this.initializeInformation();
  }

  initializeInformation(){
      this.determineCreditRating();
      this.setCreditFactorTable();
      this.setCreditCardInfo();
      this.determineOutstandingLoanAmts();
      this.countNewCredit();
  }

  determineCreditRating(){
    this.creditScore = this.props.creditReport.creditScore;
    switch (true){
      case this.creditScore >= 800:
        this.creditRating = "Excellent";
        break;
      case this.creditScore >= 740:
        this.creditRating = "Very Good";
        break;
      case this.creditScore >= 670:
        this.creditRating = "Good";
        break;
      case this.creditScore >= 580:
        this.creditRating = "Fair";
        break;
      default:
        this.creditRating = "Poor";
        break;
      }
  }
  
  setCreditFactorTable(){
      this.reportFactors = JSON.parse(JSON.stringify(CreditReportFactors));
      this.creditReportFactors = [];
      for (let i=0; i<this.reportFactors.length; i++){
          const creditFactorObj = 
            this.props.creditReport.creditFactorArr.find(elem => elem.code === this.reportFactors[i].code); 
          const factorValue = creditFactorObj.score;
          const factorPercent = ((factorValue / this.reportFactors[i].maxValue) * 100).toFixed(0);
          let factorAssessment = "";
          switch (true) {
            case factorPercent >= 95:
              factorAssessment = "Excellent";
              break;
            case factorPercent >= 85:
              factorAssessment = "Good";
              break;
            case factorPercent >= 70:
              factorAssessment = "Fair";
              break;
            case factorPercent >= 55:
              factorAssessment = "Needs Improvement";
              break;
            default:
              factorAssessment = "Limited";
              break;
          }
          const reportFactor = {label1: this.reportFactors[i].factor, label2: factorPercent + "%",
                label3: factorAssessment };
          this.creditReportFactors.push(reportFactor);
      }
  }

  setCreditCardInfo(){
    this.creditLimit = this.props.creditInfo.creditMaxAmount;
    this.currentBalance = this.props.creditInfo.prevPeriodOutstandBalance;
    this.utilization = (this.currentBalance / this.creditLimit * 100).toFixed(0);
    const paymentHistoryObj = creditReportCreditCard(this.props.creditInfo, 
        this.props.creditReport.creditHistoryMonths, this.props.nbrMonths );
    this.status = paymentHistoryObj.status;
    this.nbrPayments = paymentHistoryObj.nbrPayments;
    this.latePayCount = paymentHistoryObj.latePayCount;
    this.oldestLatePayText = paymentHistoryObj.oldestLatePayText;
    this.mostRecentLatePayText = paymentHistoryObj.mostRecentLatePayText;
  }

  determineOutstandingLoanAmts(){
      const loanTable = this.props.loanTable;
      this.loanArr = [];
      for (let i=0; i<loanTable.length; i++){
        if (loanTable[i].loanType === "Mortgage Insurance (PMI)"){
            //   skip PMI for credit score
        }else{
            if (loanTable[i].loanNbrMonths > 0){
                const loanTerm = loanTable[i].loanTerm * 12;
                const loanDescArr = loanTable[i].loanDesc.split('-');
                let loanDescDetail = loanTable[i].loanDesc;
                if (loanTable[i].loanType === "College Loan"){
                    loanDescDetail = loanDescArr[1];
                }
                const remainingBalance = loanBalanceCalcFunction(loanTable[i].loanTotAmt, loanTable[i].loanIntRate,
                    loanTable[i].loanAmt, loanTerm, loanTable[i].loanNbrMonths);
                const loanObj = {loanType: loanTable[i].loanType + " - " + loanDescDetail, totLoanAmt: loanTable[i].loanTotAmt,
                    remainingBal: remainingBalance, payment: loanTable[i].loanAmt, 
                    payStatus: "Open", payHistory: "onTime" }
                this.loanArr.push(loanObj);
            }
        }
      }
  }

  countNewCredit(){
      this.newCreditArr = this.props.creditReport.newCreditArr;
  }

  render() { 
      const creditScoreFactors = this.creditReportFactors.map((factorValues, key) =>
            <ThreeColumnTableCard key={key} outInfo={factorValues} 
                infoType="label-label-label" 
                column1Class="text-left font-weight-bold p-0" />
            );
      const loanTableInfo = this.loanArr.map((loanInfo, indx) =>
          <CreditReportLoanCard key={indx} loanInfo={loanInfo}  />
          );
       const newCreditList = this.newCreditArr.map((creditItem,key) =>
          <TwoColumnTableCard key={key} infoType="date-label" outInfo={creditItem}  />
          );  
                 
  
  return <>
   
        <Modal show={this.props.show}  onHide={() => this.props.onClose()} 
            size={this.modalSize} animation={false}>
        <Modal.Header className="backgroundTopBottom" closeButton>
            <Modal.Title>Credit Report - Your Financial Profile</Modal.Title> 
          
          </Modal.Header>
          <Modal.Body className={`custom-scroll-modal-body ${this.modalClass}`}>
              <span>    
                  <h5 className="text-center">General Information:</h5>
                  <div className='ml-4'><b>Name: </b>{this.props.user}</div>
                  <div className="ml-4"><b>Report Date: </b>{reformatDateToDisplay(this.props.creditReport.creditReportDate)}</div>
                   <hr className="modal-divider mb-2" />
                  <h5 className="text-center mt-2">Credit Summary:</h5>
                  <div className="ml-4"><b>Credit Score: </b>{standardNumberFormat(this.creditScore)}</div>
                  <div className="ml-4"><b>Range: </b>300 - 850</div>
                  <div className="ml-4"><b>Credit Rating: </b>{this.creditRating}</div>
              
                  <table className="mt-2 table table-hover">
                    <tbody>
                        <tr>
                          <th>Factor</th>
                          <th>Value</th>
                          <th>Status</th>
                        </tr>
                        {creditScoreFactors}
                    </tbody>
                  </table>
                   <hr className="modal-divider mb-2" />

                  <h5 className="text-center">Accounts Overview</h5>
                  <h6 className="font-weight-bold">Open Accounts</h6>
                  <div className="mt-2 font-weight-bold">Student Credit Card</div>
                  {this.props.creditInfo.currentlyActive ?
                    <span>
                      <div><b>Credit Limit: </b>{doubleToStringMonthly(this.creditLimit)}</div>
                      <div><b>Current Balance: </b>{doubleToStringMonthly(this.currentBalance)} 
                        &nbsp;(balance at end of month)</div>
                      <div><b>Utilization: </b>{standardNumberFormat(this.utilization)}%</div>
                      <div><b>Status: </b>{this.status}</div>
                    </span>
                  :
                    <div>
                      Credit utilization only applies if you have credit cards.
                      If you don’t have a credit card, you are only getting
                      partial credit for utilization.
                    </div>
                  }
                  {this.latePayCount > 0 ?
                    <div>
                      <div><b>Payment History: &nbsp;</b>{this.latePayCount}&nbsp;
                          Late Payments </div>
                      <div className="ml-3">{this.oldestLatePayText}</div>
                      <div className="ml-3">{this.mostRecentLatePayText}</div>
                    </div>
                  :
                    <div><b>Nbr of On-Time Payments: </b>{this.nbrPayments}</div>
                  }
                  {loanTableInfo}
                 <hr className="modal-divider mb-2" />
                 <h5 className="text-center mt-2">Credit Inquiries</h5>
                 <table className="table table-hover">
                  <tbody>
                      <tr>
                          <th className="text-center">Date</th>
                          <th className="text-center">Credit Type</th>
                      </tr>
                        {this.newCreditArr.length > 0  ?
                            <>
                              {newCreditList}
                            </>                 
                        :
                            <tr>
                              <td colSpan="2" className="text-center">No New Credit Inquiries to Report</td>
                            </tr>
                        }
                    </tbody>
                 </table>
                  <hr className="modal-divider mb-2" />
                 <h5 className="text-center mt-2">Credit Score Insights</h5>
                 <ul className="bulleted-list">
                    <li>High credit card balances increase credit utilization and lower credit score.</li>
                    <li>Making payments on time consistently improves payment history.</li>
                    <li>Length of credit history improves naturally as your accounts age. Your credit score 
                        improves as long as your accounts stay open. 
                    </li>
                 </ul>
              </span>
            
          </Modal.Body>
          <Modal.Footer className="backgroundTopBottom">
              <img src="./assets/sidebar_icon.png" className="train_icon_thumbnail_img mr-5"
                alt="trainIcon"/>
              <Button  variant="info"   onClick={() => this.props.onClose()}>
                   Close
              </Button>
          </Modal.Footer>
          </Modal>
    
    </>
  }


  componentDidMount(){
      this._isMounted = true;
        
  }

 
}
export default CreditReportModal;